import {
  ITaxonomyCategorizedData,
  ITaxonomyContent,
} from "../TaxonomyTags.types";

export const searchTags = (
  query: string,
  categorizedData: ITaxonomyCategorizedData,
): ITaxonomyCategorizedData => {
  if (!query) return categorizedData;

  const result: ITaxonomyCategorizedData = {};

  Object.keys(categorizedData).forEach((level) => {
    categorizedData[level]?.forEach((tag) => {
      if (tag.label.toLowerCase().includes(query.toLowerCase())) {
        addTagToResult(tag, level, result);
        addAllParentsToResult(tag, categorizedData, result);
      }
    });
  });

  return result;
};

const addTagToResult = (
  tag: ITaxonomyContent,
  level: string,
  result: ITaxonomyCategorizedData,
) => {
  const levelTags = result[level] ?? (result[level] = []);
  if (!levelTags.some((existingTag) => existingTag.id === tag.id)) {
    levelTags.push(tag);
  }
};

const addAllParentsToResult = (
  tag: ITaxonomyContent,
  categorizedData: ITaxonomyCategorizedData,
  result: ITaxonomyCategorizedData,
) => {
  let currentTag = tag;
  while (currentTag.parentId) {
    const parentLevel = `level${Number(currentTag.level) - 1}`;
    const parentTag = findParentTag(currentTag.parentId, categorizedData);
    if (parentTag) {
      addTagToResult(parentTag, parentLevel, result);
      currentTag = parentTag;
    } else {
      break;
    }
  }
};

const findParentTag = (
  parentId: string,
  categorizedData: ITaxonomyCategorizedData,
): ITaxonomyContent | undefined => {
  return Object.values(categorizedData)
    .flat()
    .find((t) => t.id === parentId);
};
